import api, { getErrorMessage } from './api';

const emailService = {
  /**
   * Superadmin email backend smoke test. Sends a test email through the
   * configured provider (SES/SMTP) and surfaces the real send result.
   * Returns { provider, emails_enabled, from_email, sent, message_id }.
   * On a backend failure (e.g. SES rejected the message) the thrown error
   * message contains the exact provider error (from the 502 `detail`).
   *
   * @param {string} emailTo - Recipient address for the test email.
   */
  sendTestEmail: async (emailTo) => {
    try {
      const response = await api.post(
        '/api/v1/utils/email-diagnostics/',
        null,
        { params: { email_to: emailTo } }
      );
      // Tolerate both the standardized envelope ({ data: {...} }) and a
      // plain body.
      return response.data?.data ?? response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },
};

export default emailService;
